import.meta.glob('~/images/*')
import.meta.glob('~/images/**/*')
import '@fancyapps/ui'
import './modules/accordion-anchors.js'
import initAccordion from './modules/accordion.js'
import './modules/equalize-height.js'
import './modules/equalize-widths.js'
import './modules/brands.js'
import './modules/sticky-sidebar.js'
import './modules/dropdowns.js'
import './modules/slider.js'
import './modules/nav-trigger.js'
import './modules/viewport-height.js'
import './modules/fixed-filter-button.js'
import './modules/handle-changing-text.js'
import './modules/video-popup.js'
import './modules/slick-slider.js'
import './modules/clickEvents.js'
import './modules/tiles.js'
import './modules/word-carousel.js'
import './modules/video.js'
import './modules/hero-video.js'
import initHotspots from './modules/hotspot.js'

import AOS from 'aos'

AOS.init({
  startEvent: 'load',
  once: true,
})

// Initialize hotspot functionality
initHotspots()

// Initialize accordion functionality
initAccordion()

// set Overview as initial Our Brands dropdown state
const navOurBrands = document.querySelector('.nav-node-our-brands')

navOurBrands.addEventListener('mouseenter', function () {
  if (window.innerWidth > 959) {
    const overviewTrigger = document.querySelector(`[data-targeted-element="overview"]`)
    const overviewTarget = document.querySelector(`[data-target-element="overview"]`)
    overviewTrigger.classList.add('is-active')
    overviewTarget.classList.add('is-active')
  }
})


const select = document.getElementById('newsroom-jumplinks')

if (select) {
  const handleChange = (event) => {
    const { value } = event.target
    const redirectTo = `${value}`
    window.location.href = redirectTo
  }

  select.addEventListener('change', handleChange)
}
